import React, { useState } from "react";

import { Container } from "./styles";

import { BiDownload } from "react-icons/bi";

//utils
import XLSX from "sheetjs-style";
import { Filter } from "@domain/models/Filters";

import { downloadColumns } from "@resources/downloadColumns";
import { GetClientExportDataUseCase } from "@useCases/index";
import { HttpClientRepository } from "@data/repositories/index";
import { api } from "@data/api";
import DotLoader from "react-spinners/ClipLoader";
import { MapClient } from "@domain/models/MapClient";
import { Client } from "@domain/models/Client";
import { datetimeHelper } from "@helpers/datetime";
import { ClientExportData } from "@domain/models/ClientExportData";
import { arrayHelper } from "@helpers/array";

type Props = {
  type?: "dataTable" | "table";
  tableColumns?: { headerName: string; field: string }[];
  tableRows?: MapClient[] | Client[];
  filters?: Filter[];
};

function DownloadButton({
  type = "dataTable",
  tableColumns = [],
  tableRows = [],
  filters = [],
}: Props) {
  const [loading, setLoading] = useState(false);

  console.log("tableColumns: ", tableColumns);

  const xlsClientExportDataMaker = async (clientExportData: ClientExportData[]) => {
    const xlsxRows = [];
    const header = [];
    const fields = [];

    const baseColumns = downloadColumns;

    for (const column of baseColumns) {
      header.push(column.headerName);
      fields.push(column.field);
    }

    for (const item of clientExportData) {
      const obj = {};

      for (const field of fields) {
        const result = baseColumns.find((x) => x.field == field);

        if (result && result.headerName) {
          if (result.headerName.includes("Data")) {
            obj[result.headerName] = datetimeHelper.getFullDate(item[field]);
          } else {
            obj[result.headerName] = item[field];
          }
        }
      }

      xlsxRows.push(obj);
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const ws = XLSX.utils.json_to_sheet(xlsxRows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });

    const url = window.URL.createObjectURL(data);

    const a = document.createElement("a");
    a.setAttribute("href", url);

    a.setAttribute("download", "download.xlsx");
    a.click();
  };

  const handleDownload = () => {
    setLoading(true);
    const useCase = new GetClientExportDataUseCase(new HttpClientRepository(api));
    let clientIds = [];
    if (type === "dataTable" && tableRows) {
      clientIds = arrayHelper.reduceToSimple<MapClient | Client>(tableRows, "id");
    }
    useCase
      .execute({ filters, clientIds })
      .then((data) => {
        xlsClientExportDataMaker(data);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container onClick={() => handleDownload()}>
      {loading ? (
        <DotLoader size={20} color={"var(--white)"} loading={true} speedMultiplier={1.5} />
      ) : (
        <BiDownload style={{ cursor: "pointer" }} size={18} color="#FFF" fill="#FFF" />
      )}
    </Container>
  );
}

export default DownloadButton;
